module.exports = __webpack_public_path__ + "img/auction.9780177b.png";